export const COMPANIES_PER_PAGE = 30;
export const TOP_COMPANIES_MAX_LIMIT = 2000;
export const TOP_COMPANY_PAGE_COUNT = Math.floor(TOP_COMPANIES_MAX_LIMIT / COMPANIES_PER_PAGE);
export const TOP_COMPANIES_BUILD_LIMIT = TOP_COMPANY_PAGE_COUNT * COMPANIES_PER_PAGE;
export const FIRST_REGULAR_COMPANY_PAGE = TOP_COMPANY_PAGE_COUNT + 1;
export const MAX_EMPLOYEES_PER_COMPANY = 5;
